/* KaminWelt — voraussichtliches Lieferdatum (4–6 Werktage ab heute, ohne Wochenenden und bundesweite Feiertage) */
(function () {
  var HOLIDAYS = [
    '2026-01-01', '2026-04-03', '2026-04-06', '2026-05-01', '2026-05-14', '2026-05-25', '2026-10-03', '2026-12-25', '2026-12-26',
    '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-01', '2027-05-06', '2027-05-17', '2027-10-03', '2027-12-25', '2027-12-26',
    '2028-01-01', '2028-04-14', '2028-04-17', '2028-05-01', '2028-05-25', '2028-06-05', '2028-10-03', '2028-12-25', '2028-12-26'
  ];

  function iso(d) {
    var m = d.getMonth() + 1, day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
  }

  function addWorkdays(start, n) {
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var count = 0;
    while (count < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w === 0 || w === 6 || HOLIDAYS.indexOf(iso(d)) > -1) continue;
      count++;
    }
    return d;
  }

  function fmt(d) {
    try {
      return d.toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' });
    } catch (e) {
      return d.getDate() + '.' + (d.getMonth() + 1) + '.';
    }
  }

  function range(min, max) {
    var now = new Date();
    return fmt(addWorkdays(now, min)) + ' – ' + fmt(addWorkdays(now, max));
  }

  function run() {
    document.querySelectorAll('[data-kw-eta]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min') || '4', 10);
      var max = parseInt(el.getAttribute('data-max') || '6', 10);
      /* data-single: nur das späteste Datum („Lieferung bis …“) */
      el.textContent = el.hasAttribute('data-single') ? fmt(addWorkdays(new Date(), max)) : range(min, max);
      var wrap = el.closest('[data-kw-eta-wrap]');
      if (wrap) wrap.hidden = false;
    });

    /* Produktseite: Lieferbox mit konkretem Datum füllen */
    document.querySelectorAll('.kw-delivery').forEach(function (box) {
      if (box.getAttribute('data-kw-eta-done')) return;
      var title = box.querySelector('.kw-delivery__title');
      var sub = box.querySelector('.kw-delivery__sub');
      if (title) title.textContent = 'Lieferung voraussichtlich: ' + range(4, 6);
      if (sub) sub.textContent = 'Bei Bestellung heute · ' + sub.textContent.trim();
      box.setAttribute('data-kw-eta-done', '1');
    });
  }

  window.kwEtaRun = run;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
